import { render, staticRenderFns } from "./PortfolioUploadSection.vue?vue&type=template&id=8411a55c&scoped=true&"
import script from "./PortfolioUploadSection.vue?vue&type=script&lang=js&"
export * from "./PortfolioUploadSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8411a55c",
  null
  
)

export default component.exports